import { crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

export const collectionMorphemeTable = crudTable(
  "collection_morpheme",
  {
    collectionId: text("collection_id").notNull(),
    // A morpheme the user added to the collection — a grapheme or a word.
    morpheme: text("morpheme").notNull(),
  },
  // `collectionId` backs the `collection.collectionMorphemes` relation join and
  // the membership `findFirst({ where: { collectionId, morpheme } })` lookups.
  // `morpheme` backs the per-morpheme membership reads (favorites star, the
  // mnemonics-panel user slice) — `findMany({ where: { morpheme } })` was a
  // full-table scan on every card reveal without it.
  (table) => [
    index("collection_morpheme_collection_id_idx").on(table.collectionId),
    index("collection_morpheme_morpheme_idx").on(table.morpheme),
  ],
);

export type CollectionMorpheme = typeof collectionMorphemeTable.$inferSelect;
